import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      areCommentsAllowed: localState.areCommentsAllowed,
      className: "wsc_content_blog_detail_comments",
      hasPost: !!state.page.postId,
      isEditMode: state.isEditMode
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
